module.exports = __webpack_public_path__ + "media/customizations/windler/logo-34fcbc447cb1a7857ebb8c0a00ee3994.png";